import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pszb",
  "use": "icon-pszb-usage",
  "viewBox": "0 0 58 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 58 46\" id=\"icon-pszb\"><path d=\"M37.542 45.725a30.531 30.531 0 0 0-9.936-20.182V15.244h.007c16.632 0 30.11 13.645 30.11 30.481H37.542zM2.51 5.084h10.037v35.565H2.51C1.126 40.649 0 39.509 0 38.107V7.618a2.522 2.522 0 0 1 2.51-2.534zM17.569 0c2.771 0 5.022 2.272 5.022 5.084v35.565c0 2.805-2.244 5.084-5.022 5.084-2.77 0-5.021-2.272-5.021-5.084V5.084c0-2.812 2.25-5.084 5.021-5.084z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol